<template>
  <van-tabbar
    v-if="$route.meta.index === 0"
    class="tabbar"
    v-model="active"
    @change="$router.push(active)"
  >
    <van-tabbar-item v-for="item in tabbars" :key="item.title" :name="item.path">
      {{ $t(item.title) }}
      <template #icon="props">
        <img :src="active === item.path ? item.active : item.inactive" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>
<script>
export default {
  data() {
    return {
      active: "",
      tabbars: [
        {
          title: "homePage",
          icon: "home-o",
          path: "/home",
          active:require('@/assets/images/tabbar-home-selected.png'),
          inactive:require('@/assets/images/tabbar-home.png'),
        },
        {
          title: "Bill",
          icon: "contact-o",
          path: "/mine/loansDisplay",
          active:require('@/assets/images/tabbar-bill-selected.png'),
          inactive:require('@/assets/images/tabbar-bill.png'),
        },
      ],
    };
  },
  created() {
    this.active = this.$route.path;
  },

  watch: {
    $route() {
      this.active = this.$route.path;

    },
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.b-layout {
  position: relative;
  width: 100%;
  max-width: 600px;
  height: 100vh;

  .tabbar {
    border-top: 1px solid #eee;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  ::v-deep(.van-tabbar-item__text) {
    font-size: 12px;
  }
  .van-tabbar{
    height: 60px;
  }
}
</style>
